import React, { useContext } from 'react'
import { ProductsContext } from '../../Context/ProductsContext.jsx'
import { FaStar } from 'react-icons/fa'
import { WishListContext } from '../../Context/WishListContext.jsx'
import { CartContext } from '../../Context/CartContext.jsx'
import { Link } from 'react-router-dom'
import { BsCartDash, BsCartPlus } from 'react-icons/bs'
import { GrNext, GrPrevious } from 'react-icons/gr'
import LoadingPage from '../LoadingPage/LoadingPage.jsx'
import { VscHeart, VscHeartFilled } from 'react-icons/vsc'
import { FiSearch } from 'react-icons/fi'
import { Fragment } from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Helmet, HelmetProvider } from 'react-helmet-async'
// import { Rating } from '@mui/material'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Products = () => {
    const { count, setSort, getSearchQuery, products, counterPrevPages, counterNextPages } = useContext(ProductsContext)
    const { addProductToWishList, removeProductFromWishList, contains, ids } = useContext(WishListContext)
    const { addProductToCart, removeProductFromCart, cartContains, cartIds } = useContext(CartContext)



    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | Products</title>
            </Helmet>
            {products?.length ? <div className="container p-2">
                <div className="sort flex justify-between px-1 sm:px-2 py-2 sm:py-3 border-b-1 rounded bg-slate-100 gap-3">
                    <div className="relative md:block flex ">
                        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <FiSearch className='text-neutral-500 text-xl' />
                        </div>
                        <input type="text" onChange={getSearchQuery} id="search-navbar" className="block w-full p-3 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Search..." />
                    </div>
                    <Menu as="div" className="relative inline-block text-left">
                        <div>
                            <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                SORT BY
                                <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                            </Menu.Button>
                        </div>

                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                            className="shadow-2xl"
                        >
                            <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <div className="py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                onClick={() => setSort(' ')}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'block px-4 py-2 text-xs tracking-wider w-full'
                                                )}
                                            >
                                                Default
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                                <div className="py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                onClick={() => setSort('-price')}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'block px-4 py-2 text-xs tracking-wider w-full'
                                                )}
                                            >
                                                PRICE HIGHT TO LOW
                                            </button>
                                        )}
                                    </Menu.Item>
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                onClick={() => setSort('price')}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'block px-4 py-2 text-xs tracking-wider w-full'
                                                )}
                                            >
                                                PRICE LOW TO HIGHT
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                                <div className="py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                onClick={() => setSort('-AvgRate')}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'block px-4 py-2 text-xs tracking-wider w-full'
                                                )}
                                            >
                                                RATE HIGHT TO LOW
                                            </button>
                                        )}
                                    </Menu.Item>
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                onClick={() => setSort('AvgRate')}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'block px-4 py-2 text-xs tracking-wider w-full'
                                                )}
                                            >
                                                RATE LOW TO HIGHT
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                                <div className="py-1">
                                    <Menu.Item>
                                        {({ active }) => (
                                            <button
                                                onClick={() => setSort('-discount')}
                                                className={classNames(
                                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                                    'block px-4 py-2 text-xs tracking-wider w-full'
                                                )}
                                            >
                                                Discount
                                            </button>
                                        )}
                                    </Menu.Item>
                                </div>
                            </Menu.Items>
                        </Transition>
                    </Menu>
                </div>
                <div className="grid p-0 sm:p-2 grid-cols-1 xxs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 gap-6 lg:gap-8 ">
                    {products?.map((product, key) => (
                        <div className="rounded border my-3 p-1 font-semibold flex flex-col justify-between group" key={key} >
                            <div className="flex justify-end m-0 p-0 ">
                                {!contains(ids, product._id) ?
                                    <button onClick={() => addProductToWishList(product?._id)} className='rounded text-red-800 p-1 border border-red-700 '><VscHeart className='group-hover:animate-bounce' size={18} /></button> :
                                    <button onClick={() => removeProductFromWishList(product?._id)} className='rounded text-red-800 p-1 border border-red-700 '><VscHeartFilled className='group-hover:animate-bounce' size={18} /></button>}
                            </div>
                            <Link to={`/products/${product._id}`} className="rounded px-1">
                                <div className="bg-black">
                                    <img src={product.mainImage?.path} className='w-full' alt="product_Image" />
                                </div>
                                <div className="my-1">
                                    <p className="text-slate-500">{`${product.brandId?.name?.charAt(0).toUpperCase() + product.brandId?.name?.slice(1).split(' ').slice(0, 10).join(' ')}`}</p>
                                    <p className="text-slate-800">{`${product.name?.charAt(0).toUpperCase() + product.name?.slice(1).split(' ').slice(0, 7).join(' ')}....`}</p>
                                </div>
                                {product.discount > 0 ? <div className="flex items-center gap-4 w-full ">
                                    <p className="text-green-700">{product.priceAfterDiscount.toFixed(2)} EGP</p>
                                    <p className="text-gray-500 text-sm line-through">{product.price} EGP</p>
                                </div> : <div className="flex items-center justify-between gap-2 w-full ">
                                    <p className="text-slate-800 ">{product.price} EGP</p>
                                </div>}
                                <div className='flex items-center gap-1.5 mt-2 bg-gray-50 shadow-sm rounded py-1 px-3 w-max my-2'>
                                    <FaStar className=" text-yellow-400" />
                                    <span>{product.AvgRate}</span>
                                    {/* <Rating name="read-only" value={product.AvgRate} readOnly precision={0.125} /> */}
                                </div>
                            </Link>
                            {!cartContains(cartIds, product._id) ?
                                <button onClick={() => addProductToCart(product._id, 1)} className='flex items-center justify-center gap-2 py-2 bg-green-600 hover:bg-green-500 text-white rounded w-full opacity-0 group-hover:opacity-100 duration-500'>
                                    <BsCartPlus className='group-hover:animate-bounce' />
                                    <span className='text-xs font-semibold  uppercase'> Add To Cart</span>
                                </button> :
                                <button onClick={() => removeProductFromCart(product._id)} className='flex items-center justify-center gap-2 py-2 bg-red-600 hover:bg-red-500 text-white rounded w-full opacity-0 group-hover:opacity-100 duration-500'>
                                    <BsCartDash className='group-hover:animate-bounce' />
                                    <span className='text-xs font-semibold  uppercase'> Remove From Cart</span>
                                </button>}
                        </div>
                    ))}
                </div>
                <div className="pag py-3 flex items-center justify-center">
                    {/* <Pagination count={totalPages} color="primary" /> */}
                    <button className="prev text-2xl mx-2 rounded border p-2" onClick={counterPrevPages} ><GrPrevious /></button>
                    <span className="font-medium text-base currant border p-2 rounded text-center">Page <span className="text-red-500" >{count}</span></span>
                    <button className="next mx-2 text-2xl  rounded border p-2" onClick={counterNextPages} ><GrNext /></button>
                </div>
            </div> : <LoadingPage />}
        </HelmetProvider>
    )
}

export default Products